import { PaginationQueryParams } from './common.interface';

export const productsFiltersArray = [
  'targets',
  'reactivities',
  'hostSpecies',
  'conjugate',
  'clonalities',
  'isotypes',
  'classifications',
  'applications',
  'suppliers',
];

export type ProductsFilters = (typeof productsFiltersArray)[number];

export const productsMultipleFilters: ProductsFilters[] = [
  'reactivities',
  'applications',
  'hostSpecies',
  'conjugate',
  'clonalities',
  'suppliers',
];

export interface SearchProductsResponse {
  totalCount: number;
  page: number;
  totalPages: number;
  products: Product[];
}

export interface SearchProductsFiltersResponse {
  name: string;
  count: number;
}

export interface Product {
  supplier: string;
  code: string;
  name: string;
  description: string | null;
  packaging: string | null;
  price: number | null;
  pricePromo: number | null;
  promoCode: string | null;
  reactivity: string | null;
  isotype: string | null;
  applications: string | null;
  hostSpecies: string | null;
  storageBuffer: string | null;
  promoEndDate: string | null;
  preservative: string | null;
  form: string | null;
  clonality: string | null;
  classifications: string | null;
  file1: string | null;
  file2: string | null;
  file3: string | null;
  INCIName: string | null;
}

export interface SearchProductsFiltersGeneralQueryParams {
  marketCategory: string;
  searchQuery?: string;
  targets?: string;
  reactivities?: string[];
  hostSpecies?: string[];
  conjugate?: string[];
  clonalities?: string[];
  isotypes?: string;
  classifications?: string;
  applications?: string[];
  suppliers?: string[];
}

export type SearchProductsFiltersTargetsQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'targets'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersReactivitiesQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'reactivities'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersHostSpeciesQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'hostSpecies'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersConjugateQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'conjugate'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersClonalitiesQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'clonalities'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersIsotypesQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'isotipes'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersClassificationsQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'classifications'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersApplicationsQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'applications'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export type SearchProductsFiltersSuppliersQueryParams = Omit<
  SearchProductsFiltersGeneralQueryParams,
  'suppliers'
> &
  Partial<PaginationQueryParams> & {
    filterSearchQuery?: string;
  };

export interface SearchProductsQueryParams
  extends SearchProductsFiltersGeneralQueryParams {
  page?: number;
  pageLength?: number;
}

export interface DownloadGlobeDocumentsQueryParams {
  id: string;
}

export interface GetDocuementsQueryParams {
  id: string;
}

export interface GetDocuementsResponse {
  id: string;
  name: string;
}
